import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Typography } from 'antd';

import ItemTemplateGroup from './item-template-group';
import AddItemTemplate from './add-item-template';
import EditItemTemplate from './edit-item-template';
import { ItemTypes } from './utils';
import { EmptyContent } from '@common/components';

export default function ItemTemplateList({ worksListTemplateId, items }) {
  const [editingItem, setEditingItem] = useState();
  const { Title } = Typography;

  const groups = items.reduce((accumulator, current) => {
    accumulator[current.type] = [...(accumulator[current.type] || []), current];
    return accumulator;
  }, {});

  const groupsComponents = ItemTypes.map((type) => {
    if (!groups[type]) return null;
    return (
      <ItemTemplateGroup
        key={type}
        type={type}
        items={groups[type]}
        setEditingItem={setEditingItem}
      />
    );
  });

  const dismissEdit = () => {
    setEditingItem(null);
  };

  return (
    <>
      <Row className="ItemTemplateList" justify="space-between">
        <Col>
          <Title level={2}>Compliance List Items</Title>
        </Col>
        <Col>
          <AddItemTemplate worksListTemplateId={worksListTemplateId} />
          {editingItem && (
            <EditItemTemplate item={editingItem} dismiss={dismissEdit} />
          )}
        </Col>
      </Row>
      {items.length > 0 ? (
        groupsComponents
      ) : (
        <EmptyContent
          imagePath="./onboarding/onboarding-empty-state.svg"
          text="Compliance List still doesn't have any items."
        />
      )}
    </>
  );
}

ItemTemplateList.propTypes = {
  worksListTemplateId: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};
